<template>
  <vue-ladda :class="[{cursorPointer:!disabled}, `hr-sys-button button-${button} button-${color}`]"
             :data-spinner-color="getSpinnerColor()"
             :disabled="disabled"
             :loading="loading"
             :type="type"
             @click="$emit('click', $event)"
             data-size="s"
             data-style="zoom-in">
    <slot>
      <BaseIcon :name="icon" fixed-width/>
    </slot>
  </vue-ladda>
</template>

<script>
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'

  export default {
    name:'BaseButton',
    components:{
      VueLadda
    },
    props:{
      icon:{
        type:String,
        default:null
      },
      title:{
        type:String,
        default:null
      },
      button:{
        type:String,
        default:'border'
      },
      color:{
        type:String,
        default:'primary'
      },
      loading:{
        type:Boolean,
        default:false
      },
      type:{
        type:String,
        default:'button'
      },
      disabled:{
        type:[Boolean, String]
      }
    },
    methods:{
      getSpinnerColor() {
        if (this.button !== 'border') {
          return 'white';
        }
        switch (this.color) {
          case 'primary' :
            return '#7367F0';
          case 'success' :
            return '#28C76F';
          case 'danger' :
            return '#EA5455';
          case 'warning' :
            return '#FF9F43';
          default:
            return '#7367F0';
        }
      }
    }
  }
</script>

<style lang="scss">

</style>
